export const hero = {
  lawyerName: "Abogado Especialista",
  lawyerTitle: "Visa Beckham & Residencia en España",
  title: "Obtén tu Visa Beckham y vive en España como nómada digital",
  subtitle: "Te ayudamos a conseguir tu residencia en España y aprovechar el régimen fiscal especial Beckham. Proceso rápido, seguro y con acompañamiento legal completo.",
  highlight: "✨ Ahorra hasta 76% en impuestos con la Ley Beckham",
  eligibilityAnalysis: "Análisis de Elegibilidad",
  eligibilityDesc: "Evaluamos tu caso en 24h",
  personalizedStrategy: "Estrategia Personalizada",
  strategyDesc: "Plan adaptado a tu situación",
  documentChecklist: "Checklist de Documentos",
  checklistDesc: "Lista completa y organizada",
  zoomSession: "Sesión por Zoom",
  sessionDesc: "Consulta legal personalizada",
  consultationTitle: "Consulta Legal Especializada",
  consultationDesc: "Agenda tu consulta con nuestro equipo de abogados expertos",
  priceFrom: "Desde",
  responseTime: "Tiempo de respuesta",
  bookConsultation: "Agendar Consulta",
  guarantees: "Garantía de satisfacción 100%",
  ctaQualify: "¿Califico para la Visa Beckham?"
};

export const visaIntro = {
  title: "¿Qué es la Visa Beckham?",
  subtitle: "El régimen fiscal especial que te permite pagar solo 24% de impuestos en España",
  benefit1Title: "Impuesto Fijo del 24%",
  benefit1Desc: "En lugar del 47% progresivo estándar",
  benefit2Title: "Solo Ingresos Españoles",
  benefit2Desc: "Tus ingresos internacionales no tributan en España",
  benefit3Title: "Válido por 6 Años",
  benefit3Desc: "Mantén el beneficio fiscal durante 6 años completos",
  benefit4Title: "Para Profesionales",
  benefit4Desc: "Ideal para nómadas digitales, deportistas y ejecutivos",
  description: "La Ley Beckham es un régimen fiscal especial en España que permite a profesionales extranjeros pagar un impuesto fijo del 24% sobre sus ingresos españoles, en lugar del impuesto progresivo que puede llegar hasta el 47%. Además, tus ingresos obtenidos fuera de España no tributan aquí, lo que representa un ahorro fiscal significativo para nómadas digitales y profesionales internacionales."
};

export const whoCanApply = {
  title: "¿Para Quién es la Visa Beckham?",
  subtitle: "Requisitos principales para aplicar al régimen especial",
  requirement1: "No haber sido residente fiscal en España en los últimos 5 años",
  requirement2: "Trasladarte a España por motivos laborales o profesionales",
  requirement3: "Tener un contrato laboral, ser autónomo o director de empresa",
  requirement4: "Solicitar el régimen dentro de los 6 meses desde tu llegada",
  idealFor: "Ideal para:",
  profile1: "Nómadas Digitales",
  profile1Desc: "Trabajadores remotos que quieren establecerse en España",
  profile2: "Emprendedores",
  profile2Desc: "Fundadores de startups y empresarios internacionales",
  profile3: "Ejecutivos",
  profile3Desc: "Profesionales de alto nivel trasladados a España",
  profile4: "Deportistas",
  profile4Desc: "Atletas profesionales que firman con equipos españoles"
};

export const process = {
  title: "Proceso Simple en 4 Pasos",
  subtitle: "Te acompañamos en cada etapa del proceso",
  step1Title: "1. Consulta Inicial",
  step1Desc: "Evaluamos tu caso y elegibilidad para la Visa Beckham",
  step2Title: "2. Preparación de Documentos",
  step2Desc: "Te guiamos en la recopilación y preparación de toda la documentación necesaria",
  step3Title: "3. Solicitud de Visa",
  step3Desc: "Presentamos tu solicitud ante las autoridades españolas",
  step4Title: "4. Obtención y Mudanza",
  step4Desc: "Recibes tu visa y te ayudamos con los primeros pasos en España"
};

export const pricing = {
  title: "Planes de Consultoría",
  subtitle: "Elige el servicio que mejor se adapte a tus necesidades",
  plan1Title: "Consulta Normal",
  plan1Price: "80",
  plan1Feature1: "Sesión de 45 minutos por Zoom",
  plan1Feature2: "Análisis de elegibilidad completo",
  plan1Feature3: "Estrategia personalizada",
  plan1Feature4: "Checklist de documentos",
  plan1Feature5: "Respuesta en 24-48 horas",
  plan1Button: "Agendar Consulta",
  plan2Title: "Consulta Urgente",
  plan2Price: "150",
  plan2Popular: "Más Popular",
  plan2Feature1: "Sesión de 60 minutos por Zoom",
  plan2Feature2: "Análisis prioritario en 12 horas",
  plan2Feature3: "Estrategia detallada paso a paso",
  plan2Feature4: "Checklist + plantillas de documentos",
  plan2Feature5: "Seguimiento por email 7 días",
  plan2Feature6: "Respuesta en 12 horas",
  plan2Button: "Agendar Urgente",
  plan3Title: "Consulta en Inglés",
  plan3Price: "120",
  plan3Feature1: "45-minute Zoom session in English",
  plan3Feature2: "Complete eligibility analysis",
  plan3Feature3: "Personalized strategy",
  plan3Feature4: "Document checklist in English",
  plan3Feature5: "Response within 24-48 hours",
  plan3Button: "Book Consultation"
};

export const calculator = {
  title: "Calculadora de Ahorro Fiscal",
  subtitle: "Descubre cuánto puedes ahorrar con la Ley Beckham",
  incomeLabel: "Tu ingreso anual (€)",
  incomePlaceholder: "Ej: 60000",
  standardTax: "Impuesto Estándar Español",
  beckhamTax: "Con Ley Beckham (24%)",
  savings: "Tu Ahorro Anual",
  calculate: "Calcular Ahorro",
  note: "* Cálculo aproximado. El ahorro real puede variar según tu situación específica."
};

export const whySpain = {
  title: "¿Por Qué España?",
  subtitle: "El destino perfecto para nómadas digitales y profesionales internacionales",
  reason1Title: "Calidad de Vida",
  reason1Desc: "Clima mediterráneo, gastronomía excepcional y cultura vibrante",
  reason2Title: "Ubicación Estratégica",
  reason2Desc: "En el corazón de Europa con excelentes conexiones internacionales",
  reason3Title: "Coste de Vida Razonable",
  reason3Desc: "Más económico que otras capitales europeas",
  reason4Title: "Infraestructura Digital",
  reason4Desc: "Internet de alta velocidad y espacios de coworking en todas las ciudades",
  reason5Title: "Comunidad Internacional",
  reason5Desc: "Gran comunidad de expats y nómadas digitales",
  reason6Title: "Sistema de Salud",
  reason6Desc: "Uno de los mejores sistemas de salud del mundo"
};

export const whyUs = {
  title: "¿Por Qué Elegirnos?",
  subtitle: "Experiencia y resultados comprobados",
  stat1: "500+",
  stat1Label: "Visas Aprobadas",
  stat2: "98%",
  stat2Label: "Tasa de Éxito",
  stat3: "24h",
  stat3Label: "Tiempo de Respuesta",
  stat4: "4.9/5",
  stat4Label: "Satisfacción",
  feature1Title: "Experiencia Comprobada",
  feature1Desc: "Más de 500 casos exitosos de Visa Beckham y residencia en España",
  feature2Title: "Proceso Transparente",
  feature2Desc: "Te mantenemos informado en cada paso del proceso",
  feature3Title: "Soporte Completo",
  feature3Desc: "Desde la consulta inicial hasta tu establecimiento en España",
  feature4Title: "Equipo Especializado",
  feature4Desc: "Abogados expertos en derecho de inmigración y fiscal español"
};

export const testimonials = {
  title: "Lo Que Dicen Nuestros Clientes",
  subtitle: "Historias reales de profesionales que ya viven en España",
  testimonial1: "El proceso fue mucho más simple de lo que esperaba. El equipo me guió en cada paso y obtuve mi visa en tiempo récord. Ahora vivo en Barcelona y no podría estar más feliz.",
  testimonial1Author: "Sarah Johnson",
  testimonial1Role: "Diseñadora UX, San Francisco → Barcelona",
  testimonial2: "Gracias a la Ley Beckham estoy ahorrando miles de euros al año en impuestos. La inversión en la consultoría se pagó sola en el primer mes. Totalmente recomendado.",
  testimonial2Author: "Michael Chen",
  testimonial2Role: "Desarrollador, Nueva York → Madrid",
  testimonial3: "Como emprendedor, necesitaba certeza legal y fiscal. El equipo no solo me ayudó con la visa, sino que me asesoró sobre la mejor estructura para mi negocio en España.",
  testimonial3Author: "Laura Martínez",
  testimonial3Role: "Fundadora Startup, Miami → Valencia"
};

export const faq = {
  title: "Preguntas Frecuentes",
  subtitle: "Resolvemos tus dudas sobre la Visa Beckham",
  q1: "¿Cuánto tiempo toma obtener la Visa Beckham?",
  a1: "El proceso completo suele tomar entre 2-4 meses desde la solicitud inicial hasta la aprobación. Sin embargo, el tiempo puede variar según tu país de origen y la carga de trabajo de las autoridades españolas.",
  q2: "¿Puedo aplicar si ya estoy en España?",
  a2: "Sí, pero debes solicitar el régimen especial dentro de los 6 meses desde que te convertiste en residente fiscal en España. Es importante actuar rápido para no perder el beneficio.",
  q3: "¿Qué pasa después de los 6 años?",
  a3: "Después de 6 años, pasarás al régimen fiscal estándar español. Sin embargo, durante esos 6 años habrás ahorrado significativamente en impuestos y establecido tu vida en España.",
  q4: "¿Necesito un contrato de trabajo español?",
  a4: "No necesariamente. Puedes aplicar como empleado de una empresa española, autónomo, o incluso como director de tu propia empresa. Lo importante es demostrar actividad económica en España.",
  q5: "¿Mis ingresos de fuera de España están exentos?",
  a5: "Sí, bajo la Ley Beckham, solo tributas en España por los ingresos obtenidos en territorio español. Tus ingresos internacionales no están sujetos a impuestos españoles durante el período del régimen especial.",
  q6: "¿Puedo incluir a mi familia?",
  a6: "Sí, puedes incluir a tu cónyuge e hijos en tu solicitud de residencia. Ellos también podrán vivir legalmente en España, aunque el beneficio fiscal de la Ley Beckham aplica solo al solicitante principal."
};

export const cta = {
  title: "¿Listo para Vivir en España?",
  subtitle: "Agenda tu consulta hoy y da el primer paso hacia tu nueva vida en España con el régimen fiscal más ventajoso de Europa",
  button: "Agendar Consulta Ahora",
  guarantee: "✓ Garantía de satisfacción 100% ✓ Primera consulta sin compromiso"
};

export const footer = {
  description: "Expertos en Visa Beckham y residencia en España para nómadas digitales y profesionales internacionales.",
  servicesTitle: "Servicios",
  service1: "Visa Beckham",
  service2: "Residencia en España",
  service3: "Asesoría Fiscal",
  service4: "Consultoría Legal",
  resourcesTitle: "Recursos",
  resource1: "Calculadora de Ahorro",
  resource2: "Guía Completa",
  resource3: "Preguntas Frecuentes",
  resource4: "Blog",
  contactTitle: "Contacto",
  email: "info@visabeckham.es",
  phone: "+34 900 123 456",
  schedule: "Lun - Vie: 9:00 - 18:00",
  rights: "Todos los derechos reservados.",
  privacy: "Privacidad",
  terms: "Términos",
  cookies: "Cookies"
};

export const notifications = {
  consultation: "acaba de agendar su",
  normal: "Consulta Normal",
  urgent: "Consulta Urgente",
  english: "Consulta en Inglés",
  reserved: "reservó su"
};

export const ebook = {
  title: 'Los 8 Errores Más Comunes al Solicitar el Visado de Nómada Digital',
  description: 'Descarga esta guía gratuita y evita los errores que causan el 90% de los rechazos. Aprende exactamente qué hacer (y qué NO hacer) para conseguir tu visado sin problemas.'
};